import { connect } from 'react-redux';

import {
  getEventAggregationColumn,
  getEventAggregationType,
  getEventName,
  getMetainf,
} from '../../reducers/analyticsApp';
import { aggregationTypes } from '../../constants/event';
import { prepareDropdown } from '../../utils/common';
import EventsFieldOption from '../../components/event/FieldOption';
import { setEventAggregationColumn } from '../../actions/events/events';
import { types } from '../../constants/filter';

const filterNumberFields = (fields) =>
  fields.map((field) => ({
    ...field,
    fields: field.fields.filter((obj) => obj.type === types.NUMBER),
  }));

const mapStateToProps = (state, { id }) => {
  const aggregationType = getEventAggregationType(state, id);

  if (
    ![aggregationTypes.SUM, aggregationTypes.AVG_TOTAL, aggregationTypes.AVG_TOTAL_SPLIT].includes(
      aggregationType
    )
  ) {
    return {
      visible: false,
    };
  }

  const metainf = getMetainf(state, getEventName(state, id));
  const fields = prepareDropdown(metainf, true);

  return {
    label: 'of',
    value: getEventAggregationColumn(state, id),
    values: filterNumberFields(fields),
    visible: true,
    justifyContent: 'flex-end',
  };
};

const mapDispatchToProps = (dispatch, { id }) => ({
  onChange: (value) => dispatch(setEventAggregationColumn(id, value)),
});

const EventsAggregationFieldOption = connect(
  mapStateToProps,
  mapDispatchToProps
)(EventsFieldOption);

export default EventsAggregationFieldOption;
